import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck } from '@fortawesome/pro-solid-svg-icons/faCheck';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import get from 'lodash.get';
import messages from '../../messages';
import styles from './style.module.less';

const name = <FormattedMessage {...messages.trackedFilterLabel} />;
const checkmarkIcon = <FontAwesomeIcon className={styles['active-checkmark']} icon={faCheck} />;

export default {
  name,
  getMessageDescriptor: () => messages.trackedFilterLabel,
  render: (data) => {
    const isActive = !get(data, 'inventoryDisabled', false);
    return isActive ? checkmarkIcon : '';
  },
};
